import { Routes } from '@angular/router';
import { LayoutComponent } from 'Admin/layout/layout.component'
import { OAuth2Service } from "@ngxsuit"

export const CHILDROUTES: Routes = [
    {
        path: 'stores/:store_id/systems', component: LayoutComponent,
        children: [
            {
                "path": "apc",
                "loadChildren": "AdminPermission/apcpage/apc.module#ApcModule",
                canActivate: [OAuth2Service]
            },
        ]
    }
];

export const MENUS = [];

